var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-container"},_vm._l((_vm.dates),function(entries,date,x){return _c('div',{key:x},[_c('ScheduleDate',{attrs:{"date":date,"entries":entries,"dayIndex":x}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }